<ng-container *ngIf="isImporter || isOther">
  <div
    class="lcl-incoterm-item"
    [ngClass]="{
      'lcl-incoterm-item-is-highlighted': isHighlighted,
      'lcl-incoterm-item-is-highlighted-is-selected': isHighlighted && incotermsControl.value === enumIncotermsType.FCA
    }"
  >
    <div class="lcl-incoterm-item-border">
      <app-radio-button
        [control]="incotermsControl"
        [id]="'fca'"
        [label]="'LABELS.FCA_DESCRIPTION' | translate"
        [value]="enumIncotermsType.FCA"
      ></app-radio-button>
    </div>
  </div>

  <div
    class="lcl-incoterm-item"
    [ngClass]="{
      'lcl-incoterm-item-is-highlighted': isHighlighted,
      'lcl-incoterm-item-is-highlighted-is-selected': isHighlighted && incotermsControl.value === enumIncotermsType.FOB
    }"
  >
    <div class="lcl-incoterm-item-border">
      <app-radio-button
        [control]="incotermsControl"
        [id]="'fob'"
        [label]="'LABELS.FOB_DESCRIPTION' | translate"
        [value]="enumIncotermsType.FOB"
      ></app-radio-button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isShipper || isOther">
  <div
    class="lcl-incoterm-item"
    [ngClass]="{
      'lcl-incoterm-item-is-highlighted': isHighlighted,
      'lcl-incoterm-item-is-highlighted-is-selected': isHighlighted && incotermsControl.value === enumIncotermsType.DAT
    }"
  >
    <div class="lcl-incoterm-item-border">
      <app-radio-button
        [control]="incotermsControl"
        [id]="'dat_for'"
        [label]="'LABELS.DAT_FOR_DESCRIPTION' | translate"
        [value]="enumIncotermsType.DAT"
      ></app-radio-button>
    </div>
  </div>
  <div
    class="lcl-incoterm-item"
    [ngClass]="{
      'lcl-incoterm-item-is-highlighted': isHighlighted,
      'lcl-incoterm-item-is-highlighted-is-selected': isHighlighted && incotermsControl.value === enumIncotermsType.CPT_CFR
    }"
  >
    <div class="lcl-incoterm-item-border">
      <app-radio-button
        [control]="incotermsControl"
        [id]="'cpt_cfr'"
        [label]="'LABELS.CPT_CFR_DESCRIPTION' | translate"
        [value]="enumIncotermsType.CPT_CFR"
      ></app-radio-button>
    </div>
  </div>
</ng-container>
